<template>
  <div class="c-input c-input--icon">
    <div class="c-icon c-icon--gray u-wh24">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <use xlink:href="/assets/img/sprite.svg#password" />
      </svg>
    </div>
    <input
      class="c-input__item c-input__item"
      type="password"
      :name="name"
      value=""
      :placeholder="placeHolder"
    />
    <div v-if="withErrorMessage" class="c-error u-w470">
      <div class="c-error__text"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    withErrorMessage: Boolean,
    placeHolder: {
      type     : String,
      require  : false,
      'default': 'パスワードを入力してください',
    },
    name: {
      type     : String,
      require  : false,
      'default': 'password',
    },
  },
}
</script>
